/**
 * Delivery Slot Service
 * Public + admin endpoints for managing customer-facing time slots.
 */
import api from './api';

const deliverySlotService = {
  // ── Public ────────────────────────────────────────────────────────────────

  async getSlotsForDate(date) {
    try {
      const response = await api.get('/delivery-slots', { params: { date } });
      return { success: true, data: response.data };
    } catch (error) {
      return { success: false, error: error.response?.data?.message || 'Failed to fetch delivery slots', data: [] };
    }
  },

  // ── Admin: default slots ──────────────────────────────────────────────────

  async listAllSlots() {
    try {
      const response = await api.get('/delivery-slots/admin');
      return { success: true, data: response.data };
    } catch (error) {
      return { success: false, error: error.response?.data?.message || 'Failed to fetch slots', data: [] };
    }
  },

  async createSlot(payload) {
    try {
      const response = await api.post('/delivery-slots/admin', payload);
      return { success: true, data: response.data };
    } catch (error) {
      return { success: false, error: error.response?.data?.message || 'Failed to create slot' };
    }
  },

  async updateSlot(id, payload) {
    try {
      const response = await api.patch(`/delivery-slots/admin/${id}`, payload);
      return { success: true, data: response.data };
    } catch (error) {
      return { success: false, error: error.response?.data?.message || 'Failed to update slot' };
    }
  },

  async deleteSlot(id) {
    try {
      const response = await api.delete(`/delivery-slots/admin/${id}`);
      return { success: true, data: response.data };
    } catch (error) {
      return { success: false, error: error.response?.data?.message || 'Failed to delete slot' };
    }
  },

  // ── Admin: date-range overrides ──────────────────────────────────────────

  async listAllOverrides() {
    try {
      const response = await api.get('/delivery-slots/admin/overrides');
      return { success: true, data: response.data };
    } catch (error) {
      return { success: false, error: error.response?.data?.message || 'Failed to fetch overrides', data: [] };
    }
  },

  async createOverride(payload) {
    try {
      const response = await api.post('/delivery-slots/admin/overrides', payload);
      return { success: true, data: response.data };
    } catch (error) {
      return { success: false, error: error.response?.data?.message || 'Failed to create override' };
    }
  },

  async updateOverride(id, payload) {
    try {
      const response = await api.patch(`/delivery-slots/admin/overrides/${id}`, payload);
      return { success: true, data: response.data };
    } catch (error) {
      return { success: false, error: error.response?.data?.message || 'Failed to update override' };
    }
  },

  async deleteOverride(id) {
    try {
      const response = await api.delete(`/delivery-slots/admin/overrides/${id}`);
      return { success: true, data: response.data };
    } catch (error) {
      return { success: false, error: error.response?.data?.message || 'Failed to delete override' };
    }
  },
};

export default deliverySlotService;
